import moment from 'moment';
import { routerApp, baseUrl, enableHybrid, enableOnPremise } from '../app.module';
import hybridService from '../services/hybrid';

routerApp.controller('engineReportsController', ['$rootScope', '$scope', '$state', '$http', 'EngineReportService', 'ReportService', 'notify', 'OfflineDatabase',
 function($rootScope, $scope, $state, $http, EngineReportService, ReportService, notify, OfflineDatabase) {

    $scope.selectedLevels = ['engine-reports', 'view-engine-reports'];
    $scope.report_filter = 'me-reports';
    $scope.engineReportTypeColumnLabel = {
        'EngineReport.MEReport': 'Main Engine',
        'EngineReport.AEReport': 'Auxiliary Engine',
    }
    // update me and ae reports list after
    // after refresh engine report list
    $scope.$on('engine-reports-list', function() {
        var me = ReportService.getMEReportList();
        var ae = ReportService.getAEReportList();
        var offlineME = $rootScope.offline_me_reports;
        var offlineAE = $rootScope.offline_ae_reports;
        $scope.me_reports = enableHybrid || enableOnPremise ? OfflineDatabase.manageOnlineReportsDisplay(offlineME, me) : me;
        $scope.ae_reports = enableHybrid || enableOnPremise ? OfflineDatabase.manageOnlineReportsDisplay(offlineAE, ae) : ae;
    });

    $scope.openMEReport = function(reportId) {
        EngineReportService.getMEReport(reportId).then(function(response) {
            var report = response.data;
            report = ReportService.applyDatesOnEngineReport(report, report);
            $state.go('site.meReport', { report: null, engineReport: report, viewReport: report.status == 'completed' });
        }).catch(function(error) {
            notify({message: 'Error loading report from server, try again in a bit!', duration: 2000, classes: ['bad-notification']});
        });
    }

    $scope.openAEReport = function(reportId) {
        EngineReportService.getAEReport(reportId).then(function(response) {
            var report = response.data;
            report = ReportService.applyDatesOnEngineReport(report, report);
            $state.go('site.aeReport', { report: null, engineReport: report, viewReport: report.status == 'completed' });
        }).catch(function(error) {
            notify({message: 'Error loading report from server, try again in a bit!', duration: 2000, classes: ['bad-notification']});
        });
    }
    $scope.openOfflineEngineReport = function(offlineEngineReport) {
        var report = offlineEngineReport.report;
        $scope.pageState.setLoadingData();
        var targetState = ReportService.getEngineReportView(report);

        $state.go(targetState, {
            report: null,
            engineReport: report,
            viewReport: report.status == 'completed'
        });
        $scope.pageState.setDataLoaded();
    };

    $scope.extractData = function(reportFilter) {
        notify({message: 'Please wait, your report is being processed', duration: 2000, classes: ['warning-notification']});
        var vesselIds = [$rootScope.selectedVessel.id];
        EngineReportService.extractData(vesselIds, reportFilter).then(function(res) {
            notify({message: 'Report extract successful!', duration: 2000, classes: ['ok-notification']});
            var extractData = res.data;
            var blob = new Blob([extractData], { type: 'text/csv' });
            var objectUrl = URL.createObjectURL(blob);
            var a = document.createElement('a');
            var filename = reportFilter + ' - ' + moment().format('YYYY-MM-DD') + '.csv';
            if (vesselIds.length === 1) {
                filename = $rootScope.selectedVessel.name + ' - ' + filename;
            }
            a.href = objectUrl;
            a.download = filename;
            a.click();
        }).catch(function() {
            notify({message: 'Error extracting data, try again in a bit!', duration: 2000, classes: ['bad-notification']});
        });
    };

    $scope.getReadableReportType = function(report) {
        if (report._cls == 'EngineReport.MEReport') {
            return 'Main Engine Report';
        } else if (report._cls == 'EngineReport.AEReport') {
            return 'Aux Engine Report';
        } else {
            return report._cls;
        }
    }

    function encodeEngineReport(report, forClipboard) {
        var subject = '[tva-offline]: ' + $rootScope.selectedVessel.name + ' - ' + $scope.getReadableReportType(report) + ' - ' + report.details.report_to;        
        var newline = forClipboard? '\n': '%0D%0A';
        var body = 'Dear NavFleet Performance Support' + newline + newline;
        body += 'Please find below data our recently submitted report.' + newline + newline;
        body += 'Best Regards,' + newline + newline + newline + newline;
        body += 'This email has been auto-generated from NavFleet Performance online. Please do not make any changes to this section.' + newline;
        body += '-----------------' + newline;
        body += btoa(JSON.stringify(report)) + newline;
        body += '-----------------' + newline;
        return [subject, body];
    };

    function updateEngineReportEmailStatus(reportKey, hasBeenSent) {
        hybridService.serverEngineReportsGet(reportKey).then(function(report) {
            report.emailSent = hasBeenSent;
            hybridService.serverEngineReportsUpdate(report);
            $scope.refreshOfflineEngineReports()
        });
    };

    $scope.updateEngineReportEmailStatus = updateEngineReportEmailStatus;

    $scope.createEmailReport = function(offlineReport) {
        var report = offlineReport.report;
        // this is a backup option for vessels to email us reports in base 64 emails so that NavFleet Performance is able to parse them
        var toAddress = 'performance-report@navtor.com';
        var result = encodeEngineReport(report, false);
        var subject = result[0];
        var body = result[1];
        var href = 'mailto:' + toAddress + '?subject=' + subject + '&body=' + body;
        window.open(href);

        // set the 'emailSent' status to true on report
        // then refresh list of offline reports
        var reportKey = OfflineDatabase.getEngineReportKey(report);
        updateEngineReportEmailStatus(reportKey, true)
    };

    $scope.generateEmailReport = function(report) {
        // this is a backup-backup option for vessels with email not configurable with mailto: to email us reports in base 64 emails onto webso that NavFleet Performance is able to parse them
         var result = encodeEngineReport(report, true);
         var subject = result[0];
         var body = result[1];
         var reportKey = OfflineDatabase.getEngineReportKey(report);
         var reportType = $scope.getReadableReportType(report);
         $rootScope.emailReport = {
             email: 'performance-report@navtor.com',
             subject: subject,
             body: body,
             reportNumber: report.report_number,
             reportType: reportType,
             reportKey: reportKey
         };
     };

    $scope.downloadFile = function(filePath) {
        var fileDownloadUrl = baseUrl + "files/get_file";

        $http({
            url: fileDownloadUrl,
            method: "POST",
            data: {
                'path': filePath,
                'url_only': true
            }
        }).then(function(response) {
            var data = response.data;
            window.open(data.data);
        });
    }

    $scope.hasOfflineEngineReports = function() { 
        return ($rootScope.offline_me_reports && $rootScope.offline_me_reports.length > 0) || ($rootScope.offline_ae_reports && $rootScope.offline_ae_reports.length > 0);
    };

    $scope.syncOfflineEngineReports = function() {
 
        hybridService.messageActiveServiceWorker({
            type: 'SET_TIMEOUT',
            payload: { status: false}
        });
        $rootScope.syncingOfflineEngineReports = true;
        hybridService.serverEngineReportsQuery()
        .then(function (reports) {
            if (reports.length > 0) {
                notify({message: 'Syncing offline reports to server', duration: 3000, classes: ['warning-notification']})
                reports = reports.sort(function(a, b) { 
                    var timestampA = moment(a.report.creation_time, 'DD/MM/YYYY HH:mm').unix();
                    var timestampB = moment(b.report.creation_time, 'DD/MM/YYYY HH:mm').unix();
                    return timestampA - timestampB;
                })
                var results = reports.reduce(function(promiseChain, req) {
                    return promiseChain.then(function(response) {
                        return $http({
                            method: req.method,
                            url: req.url, 
                            data: req.body})
                            .then(function(response) {
                                var isNotAuthenticated = response.status == 401;
	                            if (isNotAuthenticated) throw Error(response.statusText);
	                            return response;
                            })
                            .then(function(response) {
                            if (req.reportStatus === 'ready' || response.status == 409) {
                                return hybridService.serverEngineReportsRemove(req.reportKey);
                            }
                        }, function(err) {
                            notify({message: 'Cannot sync to server, please check internet connection', duration: 5000, classes: ['bad-notification']})
                            return;
                        })
                    }).catch(function(err) {console.log(err)})
                }, Promise.resolve(null));
                results.then(function(response) {
                    $rootScope.syncingOfflineEngineReports = false;
                    $scope.goOnline();
                })
            } else {
                $rootScope.syncingOfflineEngineReports = false;
                notify({message: 'No offline reports to sync', duration: 3000, classes: ['ok-notification']})
                return;
            }
        })
    };
        
}]);
